export enum LiabilitiesPaymentType {
  STANDARD = 'STANDARD',
  TOP_UP = 'TOP_UP'
}
